import changeToAnalyticsFormat from "./changeToAnalyticsFormat";

export const getAnalyticsAttribute = {
  filter: "filter",
  keyword: "keyword",
  narrative: "narrative",
  searchType: "searchType",
  VehicleType: "vehicleType",
  Make: "make",
  ModelGroup: "modelGroup",
  Model: "model",
  Derivative: "derivative",
  SaleDate: "saleDate",
  SaleLocation: "auctionCentres",
  SaleType: "vendor",
  SaleChannel: "saleChannel",
  Mileage: "mileage",
  CapCleanPrice: "capClean",
  ColourGeneric: "colour",
  Grade: "grade",
  MechanicalReportType: "mechanicalReport",
  DateRegistered: "age",
  Plate: "plate",
  Transmission: "transmission",
  FuelType: "fuel",
  BodyType: "bodyType",
  EngineCapacity: "engine",
  NumberOfDoors: "doors",
  VATType: "vat",
  LogbookStatus: "v5",
  vehicletype: "vehicleType",
  make: "make",
  modelgroup: "modelGroup",
  model: "model",
  derivative: "derivative",
  saledate: "saleDate",
  salelocation: "auctionCentres",
  saletype: "vendor",
  salechannel: "saleChannel",
  mileage: "mileage",
  capcleanprice: "capClean",
  colourgeneric: "colour",
  grade: "grade",
  mechanicalreporttype: "mechanicalReport",
  dateregistered: "age",
  plate: "plate",
  transmission: "transmission",
  fueltype: "fuel",
  HybridType: "fuelTypeHybrid",
  bodytype: "bodyType",
  enginecapacity: "engine",
  numberofdoors: "doors",
  vattype: "vat",
  logbookstatus: "v5",
  hasconditionreport: "condition-report",
  HasConditionReport: "condition-report",
  HasBatteryHealthReport: "battery-grade",
  hasbatteryhealthreport: "battery-grade",
  awaitingAppraisal: "awaiting-appraisal",
  awaitingappraisal: "awaiting-appraisal",
  missingMileage: "missing-mileage",
  missingmileage: "missing-mileage",
  MileageWarranted: "warranted-mileage",
  mileagewarranted: "warranted-mileage",
};

const removeDuplicates = (data) =>
  data.filter((value, index) => data.indexOf(value) === index);

const getFilterAnalytics = (
  listOfFilters: {
    filterKey: string;
    categoryKey: string;
  }[],
  removedFilter?: any
) => {
  if (!Boolean(listOfFilters)) return null;

  const categoryKeysList = listOfFilters?.map((item) => {
    return item.categoryKey;
  });

  const lastSelectedFilter = removedFilter
    ? removedFilter?.categoryKey
    : categoryKeysList[categoryKeysList.length - 1];
  const filterToUpdate = getAnalyticsAttribute[lastSelectedFilter];

  const narrative = removeDuplicates(categoryKeysList).map(
    (item) => getAnalyticsAttribute[item]
  );

  let search = {
    filter: removedFilter ? "" : filterToUpdate,
    narrative: narrative.join(","),
  };

  search[filterToUpdate] = listOfFilters
    .filter((item) => item.categoryKey === lastSelectedFilter)
    .map((item) => changeToAnalyticsFormat(item.filterKey))
    .flat()
    .join(",");

  return search;
};

export default getFilterAnalytics;
